import * as ng from 'angular';
import { ArchiSmallServices } from '../../../../../services/archismall.service';
import { rabbitMQ } from '../../../../../third/rabbitMQ';

class WorkerFatturazioneGeneratePackagePAModalController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        '$uibModal',
        '$state',
        'store',
        'ArchiSmallServices',
        '$timeout',
        '$uibModalStack'
    ];

    private close: any;
    private settings: any;

    constructor(
        private $scope: any,
        private $rootScope: any,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private $state: ng.ui.IStateService,
        private store: ng.a0.storage.IStoreService,
        private ArchiSmallServices: ArchiSmallServices,
        private $timeout: ng.ITimeoutService,
        private $uibModalStack: ng.ui.bootstrap.IModalStackService
    ) {
        this.settings = $scope.$parent.$resolve.settings;
        this.settings.source = 'webApp';
        $scope.startWorker = (startWorkerLoops) => {
            try {
                if (rabbitMQ.client.STATE === 0) {
                    if (startWorkerLoops < 3) {
                        setTimeout(() => {
                            $scope.startWorker(startWorkerLoops + 1);
                        }, 3000);
                    } else {
                        let modalInstance = $uibModal.open({
                            animation: $scope.animationsEnabled,
                            component: 'defaultModalComponent',
                            windowClass: 'center-modal',
                            backdrop: 'static',
                            keyboard: false,
                            resolve: {
                                config: () => {
                                    return {
                                        headerIcon: 'fa fa-exclamation-triangle',
                                        headerText: 'Errore',
                                        bodyText: 'Non è stato possibile avviare la comunicazione con il server. N° tentativi ' + startWorkerLoops,
                                        buttons: [
                                            {
                                                'id': 1,
                                                'icon': 'fa fa-ban',
                                                'label': 'Annulla'
                                            },
                                            {
                                                'id': 2,
                                                'icon': 'fa fa-check-circle-o',
                                                'label': 'Riprova'
                                            }
                                        ]
                                    };
                                }
                            }
                        });
                        modalInstance.result.then((pressedButtonId) => {
                            if (pressedButtonId !== undefined) {
                                if (pressedButtonId === 1) {
                                    this.close();
                                }
                                if (pressedButtonId === 2) {
                                    // this.close();
                                    $scope.startWorker(startWorkerLoops + 1);
                                }
                            }
                        }, () => {
                            // ?
                        });
                    }
                    return 0;
                }
                rabbitMQ.send('worker_conservazione_generate_package' + $rootScope.workerNameSuffix, JSON.stringify(this.settings));
            } catch (err) {
                $rootScope.alert('error', err.message);
                return 0;
            }
            return 1;
        };
        $scope.workerResponse = $scope.startWorker(0);
        $scope.ok = () => {
            this.close();
        };
        // startWorker(0);
    }
}

export const WorkerFatturazioneGeneratePackagePAModalComponent: ng.IComponentOptions = {
    template: require('./worker-fatturazione-generate-package-pa-modal.html'),
    controller: WorkerFatturazioneGeneratePackagePAModalController,
    bindings: {
        close: '&'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pa/worker-fatturazione-generate-package-pa-modal/worker-fatturazione-generate-package-pa-modal.ts